/* global NodeList */

// FOOTBALL FIXTURES CONTROLLER
export default function(rootElement, view, data) {
  // make forEach available on NodeList
  NodeList.prototype.forEach = Array.prototype.forEach;

  // the football scorecentre end points are keyed by the parent key 'football'
  const footballData = data.football;

  // bail out if no data
  if (!footballData) {
    return;
  }

  // use the first item in the array (should only be 1 item)
  const dataItem = footballData[0];

  // check that the update function is not already bound
  if (!rootElement.update) {
    rootElement.update = view;
  }

  // push data to update function
  rootElement.update(dataItem);
}
